module.exports = __webpack_public_path__ + "static/img/312.621f952f.jpeg";